import { Box, HStack } from "@chakra-ui/react";
import { DeleteOutline as DeleteOutlineIcon } from "@mui/icons-material";
import * as React from "react";

import { GraphQLEnums } from "~/src/__generated__/GraphQLEnums";
import { FormikCheckBoxesField } from "~/src/components/common/forms/FormikCheckBoxesField";
import {
  FormikSelectField,
  type FormikSelectFieldProps,
} from "~/src/components/common/forms/FormikSelectField";
import { IconButton } from "~/src/components/common/IconButton";

export type WeekOfMonthSelectProps = Omit<
  FormikSelectFieldProps,
  "name" | "options"
>;

type Props = {
  fieldName: {
    weekOfMonth: string;
    daysOfWeek: string;
  };
  disabled?: boolean;
  onDelete?: () => void;
  weekOfMonthSelectProps?: WeekOfMonthSelectProps;
};

const weekOptions = [
  { label: "毎週", value: null },
  { label: "第1週", value: 1 },
  { label: "第2週", value: 2 },
  { label: "第3週", value: 3 },
  { label: "第4週", value: 4 },
  { label: "第5週", value: 5 },
];
const daysOptions = GraphQLEnums.DayOfWeek.slice();

export const DeliverDayOfWeeksField: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ fieldName, disabled = false, onDelete, weekOfMonthSelectProps }) => {
  return (
    <HStack width="100%">
      <Box w={"100%"} maxW={"200px"} minW={"100px"}>
        <FormikSelectField
          name={fieldName.weekOfMonth}
          options={weekOptions}
          defaultValue={weekOptions[0]}
          isDisabled={disabled}
          {...weekOfMonthSelectProps}
        />
      </Box>
      <FormikCheckBoxesField
        name={fieldName.daysOfWeek}
        options={daysOptions}
        disabled={disabled}
      />
      {onDelete && (
        <Box>
          <IconButton
            size="24px"
            onClick={onDelete}
            icon={<DeleteOutlineIcon />}
            disabled={disabled}
          />
        </Box>
      )}
    </HStack>
  );
};
